module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/light/long-right-b31209ab7da1038600fe5ce32b27a24c.png";